import { Button, Snackbar } from '@mui/material'
import { createContext, useState } from 'react'

type SnackbarAction = {label: string, onClick: ()=> void}

export const SeamlessSnackbarContext = createContext<(message: string, duration?: number, action?: SnackbarAction)=> void
>(undefined as never)

export const SeamlessSnackbarProvider: React.FC<{children: React.ReactNode}> = ({children})=> {
  const [snackbar, setSnackbar] = useState<{text: string, duration: number, action?: SnackbarAction}>()

  return <>
    <SeamlessSnackbarContext value={(message, duration, action)=> {
      // 他のスナックバーに合わせ、ボタン付きの時は押す余裕を持たせて長めに出す
      setSnackbar({text: message, duration: duration ?? (action ? 4000 : 3000), action})
    }}>
      {children}
    </SeamlessSnackbarContext>

    <Snackbar
      open={Boolean(snackbar)}
      autoHideDuration={snackbar?.duration}
      onClose={()=> { setSnackbar(undefined) }}
      message={snackbar?.text}
      action={snackbar?.action && <Button
        color='primary' size='small'
        onClick={()=> {
          snackbar.action?.onClick()
          setSnackbar(undefined)
        }}
      >
        {snackbar.action.label}
      </Button>}
      anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
    />
  </>
}